<template>
  <div class="listContainer">
    <!-- content -->
    <!-- 下载身份证等图片 -->
    <section>
      <div>
        <label><i>*</i>项目：</label>
        <a-select
          :maxTagCount="50"
          mode="multiple"
          style="width: 300px; margin-right: 10px"
          v-model="projectListImages"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择关联项目"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, i) in proListThreeImages"
            :key="i"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
        <span>
          <a-checkbox :checked="checkedImages" @change="selectedAllImages"
            >全选</a-checkbox
          >
        </span>
      </div>
      <div v-show="roleImageList != ''">
        <label><i>*</i>岗位：</label>
        <a-checkbox-group v-model="roleIdsImage">
          <a-checkbox
            v-for="(item, i) in roleImageList"
            :key="i"
            :value="item.id"
          >
            {{ item.role_name }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
      <div v-show="roleIdsImage != ''">
        <label><i>*</i>员工：</label>
        <a-select
          :maxTagCount="30"
          mode="multiple"
          style="width: 300px; margin-right: 10px"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择员工"
          v-model="workerIdsImage"
        >
          <a-select-option
            :value="item.user_id"
            v-for="(item, i) in workerListImage"
            :key="i"
            >{{ item.user_name }}</a-select-option
          >
        </a-select>
        <span>
          <a-checkbox
            :checked="checkedImageWorker"
            @change="selectedAllImageWorker"
            >全选</a-checkbox
          >
        </span>
      </div>
      <div class="submitStyle">
        <a-button @click="onResetImages">重置</a-button>
        <a-button type="primary" @click="downloadImage">下载</a-button>
      </div>
    </section>
    <!-- 下载身份证等图片 end-->
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      upTxt: "下载",
      businessList: [],
      project_id: [],
      searchDate: [],
      project_ids: [],
      upTxtZip: "下载",
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      selectedOneVal: "",
      selectedTwoVal: "",
      checked: false,
      project_list: [],
      selectedOneValContract: "",
      selectedTwoValContract: "",
      projectListContract: [],
      proListOneContract: [],
      proListTwoContract: [],
      proListThreeContract: [],
      checkedContract: false,
      contractList: [],
      selectedOneValImages: "",
      selectedTwoValImages: "",
      projectListImages: [],
      proListOneImages: [],
      proListTwoImages: [],
      proListThreeImages: [],
      checkedImages: false,
      roleContractList: [],
      roleImageList: [],
      roleIdsImage: [],
      roleIdsContract: [],
      workerListContract: [],
      checkedContractWorker: false,
      workerIdsContract: [],
      sign_agreement_ids: [],
      workerIdsImage: [],
      workerListImage: [],
      checkedImageWorker: false,
      dateContract: null,
      start_date: "",
      end_date: "",
      on_job: "",
      type: "",
      moment
    };
  },
  mounted() {
    this.getBusiness(); //获取项目列表
    this.getProOne(); //一级项目
    this.getContract(); //获取合同
    this.getWorker("", "", 0); //
  },
  watch: {
    projectListContract() {
      this.getRole(this.projectListContract, 1); //获取项目下岗位
      this.getWorker(this.projectListContract, this.roleIdsContract, 1);
    },
    roleIdsContract() {
      this.getWorker(this.projectListContract, this.roleIdsContract, 1);
    },
    projectListImages() {
      this.getRole(this.projectListImages, 2); //获取项目下岗位
      this.getWorker(this.projectListImages, this.roleIdsImage, 2);
    },
    roleIdsImage() {
      this.getWorker(this.projectListImages, this.roleIdsImage, 2);
    },
    sign_agreement_ids() {
      this.getWorker(this.projectListContract, this.roleIdsContract, 1);
    }
  },
  methods: {
    selectedDate(dates, dateStrings) {
      // console.log(dateStrings);
      this.start_date = dateStrings[0];
      this.end_date = dateStrings[1];
      this.checkedContractWorker = false;
      this.getWorker(this.projectListContract, this.roleIdsContract, 1);
    },
    selectedAllImageWorker(e) {
      this.checkedImageWorker = e.target.checked;
      if (e.target.checked) {
        this.workerListImage.forEach(element => {
          if (this.workerIdsImage.indexOf(element.user_id) == -1) {
            // console.log(element.id)
            this.workerIdsImage.push(element.user_id);
          }
          // console.log(element)
        });
      } else {
        this.workerIdsImage = [];
      }
    },
    selectedAllContractWorker(e) {
      this.checkedContractWorker = e.target.checked;
      if (e.target.checked) {
        this.workerListContract.forEach(element => {
          if (this.workerIdsContract.indexOf(element.user_id) == -1) {
            // console.log(element.id)
            this.workerIdsContract.push(element.user_id);
          }
          // console.log(element)
        });
      } else {
        this.workerIdsContract = [];
      }
    },
    getWorker(pid, rid, key) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/getUserByProjectAndAgreement";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        project_ids: JSON.stringify(pid),
        role_ids: JSON.stringify(rid),
        sign_agreement_ids: JSON.stringify(this.sign_agreement_ids),
        start_date: this.start_date,
        end_date: this.end_date
      };
      if (key != 1) {
        delete params.sign_agreement_ids;
      }
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          // console.log(res.data.data);
          switch (key) {
            case 0:
              // this.workerListContract = res.data.data;
              // this.workerListImage = res.data.data;
              break;
            case 1:
              this.workerIdsContract = [];
              this.workerListContract = res.data.data;
              break;
            case 2:
              this.workerIdsImage = [];
              this.workerListImage = res.data.data;
              break;
          }
        }
      });
    },
    getRole(ids, key) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/getRoleByProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_ids: JSON.stringify(ids)
        })
        .then(res => {
          if (res.data.code == 200) {
            key == 1
              ? (this.roleContractList = res.data.data)
              : (this.roleImageList = res.data.data);
          }
        });
    },
    selectedOneImages(id) {
      this.checkedImages = false;
      this.selectedTwoValImages = "";
      this.getProID(id, 1, "3"); //获取下级项目
      this.getThreePro(id, "3");
    },
    selectedTwoImages(id) {
      this.checkedImages = false;
      this.getProID(id, 2, "3"); //获取下级项目
    },
    selectedAllImages(e) {
      this.checkedImages = e.target.checked;
      if (this.selectedOneValImages == "") {
        this.projectListImages = [];
      }
      if (e.target.checked) {
        this.proListThreeImages.forEach(element => {
          if (this.projectListImages.indexOf(element.id) == -1) {
            this.projectListImages.push(element.id);
          }
        });
      } else {
        this.projectListImages = [];
      }
    },
    getContract() {
      let url = this.httpsBasic.url + this.httpsBasic.user + "Sign/getList";
      axios
        .post(url, {
          per_page: 100000,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.contractList = res.data.data.data;
            // console.log(this.contractList);
          }
        });
    },
    selectedOneContract(id) {
      this.checkedContract = false;
      this.selectedTwoValContract = "";
      this.getProID(id, 1, "2"); //获取下级项目
      this.getThreePro(id, "2");
    },
    selectedTwoContract(id) {
      this.checkedContract = false;
      this.getProID(id, 2, "2"); //获取下级项目
    },
    selectedAllContract(e) {
      this.checkedContract = e.target.checked;
      if (this.selectedOneValContract == "") {
        this.projectListContract = [];
      }
      if (e.target.checked) {
        this.proListThreeContract.forEach(element => {
          if (this.projectListContract.indexOf(element.id) == -1) {
            // console.log(element.id)
            this.projectListContract.push(element.id);
          }
          // console.log(element)
        });
      } else {
        this.projectListContract = [];
      }
    },
    onReset() {
      this.project_list = [];
      this.checked = false;
      this.selectedOneVal = "";
      this.on_job = "";
      this.type = "";
      this.selectedTwoVal = "";
      this.proListOne = [];
      this.proListTwo = [];
      this.proListThree = [];
      this.getProOne(); //一级项目
      this.getBusiness(); //获取项目列表
    },
    onResetContract() {
      this.dateContract = null;
      this.start_date = "";
      this.end_date = "";
      this.projectListContract = [];
      this.checkedContract = false;
      this.selectedOneValContract = "";
      this.selectedTwoValContract = "";
      this.roleIdsContract = [];
      this.proListOneContract = [];
      this.proListTwoContract = [];
      this.proListThreeContract = [];
      this.workerIdsContract = [];
      this.checkedContractWorker = false;
      this.sign_agreement_ids = [];
      this.getProOne(); //一级项目
      this.getWorker("", "", 0);
      this.getBusiness(); //获取项目列表
    },
    onResetImages() {
      this.projectListImages = [];
      this.checkedImages = false;
      this.selectedOneValImages = "";
      this.roleIdsImage = [];
      this.selectedTwoValImages = "";
      this.proListOneImages = [];
      this.proListTwoImages = [];
      this.proListThreeImages = [];
      this.workerIdsImage = [];
      this.checkedImageWorker = false;
      this.getProOne(); //一级项目
      this.getWorker("", "", 0);
      this.getBusiness(); //获取项目列表
    },
    selectedAll(e) {
      this.checked = e.target.checked;
      if (this.selectedOneVal == "") {
        this.project_list = [];
      }
      if (e.target.checked) {
        this.proListThree.forEach(element => {
          if (this.project_list.indexOf(element.id) == -1) {
            // console.log(element.id)
            this.project_list.push(element.id);
          }
          // console.log(element)
        });
      } else {
        this.project_list = [];
      }
    },
    selectedOne(id) {
      this.checked = false;
      this.selectedTwoVal = "";
      this.getProID(id, 1, "1"); //获取下级项目
      this.getThreePro(id, "1");
      // console.log(id);
    },
    selectedTwo(id) {
      this.checked = false;
      this.getProID(id, 2, "1"); //获取下级项目
    },
    getThreePro(id, key) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/projectListByProjectTop";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            switch (key) {
              case "1":
                this.proListThree = res.data.data;
                break;
              case "2":
                this.proListThreeContract = res.data.data;
                break;
              case "3":
                this.proListThreeImages = res.data.data;
                break;
            }

            // console.log(this.proListThree);
          }
        });
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "contract/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            this.proListOneImages = res.data.data;
            this.proListOneContract = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level, key) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              switch (key) {
                case "1":
                  this.proListTwo = res.data.data;
                  break;
                case "2":
                  this.proListTwoContract = res.data.data;
                  break;
                case "3":
                  this.proListTwoImages = res.data.data;
                  break;
              }
            } else if (level == 2) {
              switch (key) {
                case "1":
                  this.proListThree = res.data.data;
                  break;
                case "2":
                  this.proListThreeContract = res.data.data;
                  break;
                case "3":
                  this.proListThreeImages = res.data.data;
                  break;
              }
            }
            // console.log(this.proList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChange(date, dateString) {
      this.searchDate = dateString;
      // console.log(date, dateString);
    },
    getBusiness() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.proListThree = res.data.data;
          this.proListThreeImages = res.data.data;
          this.proListThreeContract = res.data.data;
        }
      });
    },
    downloadImage() {
      let _this = this;
      if (this.workerIdsImage != "") {
        this.$confirm({
          title: "是否确定下载员工身份图片?",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.downZipImage();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("标记*为必填项");
      }
    },
    downZipImage() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/downloadIdcardImage?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&user_ids=" +
        JSON.stringify(this.workerIdsImage);
    },
    downloadContract() {
      let _this = this;
      if (this.sign_agreement_ids != "" && this.workerIdsContract != "") {
        this.$confirm({
          title: "是否确定下载员工合同?",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.upFollowContract();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("标记*为必填项");
      }
    },
    upFollowContract() {
      // console.log(
      //   this.httpsBasic.url +
      //     this.httpsBasic.user +
      //     "Contract/downloadAgreement?token=" +
      //     window.localStorage.getItem("xnwfPcToken") +
      //     "&sign_agreement_ids=" +
      //     JSON.stringify(this.sign_agreement_ids) +
      //     "&user_ids=" +
      //     JSON.stringify(this.workerIdsContract) +
      //     "&project_ids=" +
      //     JSON.stringify(this.projectListContract) +
      //     "role_ids" +
      //     JSON.stringify(this.roleIdsContract)
      // );
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/downloadAgreement?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&sign_agreement_ids=" +
        JSON.stringify(this.sign_agreement_ids) +
        "&user_ids=" +
        JSON.stringify(this.workerIdsContract) +
        "&project_ids=" +
        JSON.stringify(this.projectListContract) +
        "&role_ids=" +
        JSON.stringify(this.roleIdsContract);
    },
    submitUpload() {
      let _this = this;
      if (this.project_list != "") {
        this.$confirm({
          title: "是否确定下载在职员工表单?",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.upFollow();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("请选择项目!");
      }
    },
    upFollow() {
      this.downloadTxt = "下载中...";
      let start = "",
        end = "";
      if (this.searchDate != "") {
        start = this.searchDate[0];
        end = this.searchDate[1];
      }
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "user/downloadGuard?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&project_ids=" +
        JSON.stringify(this.project_list) +
        "&start_date=" +
        start +
        "&end_date=" +
        end +
        "&on_job=" +
        this.on_job +
        "&type=" +
        this.type;

      this.downloadTxt = "下载";
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  > section {
    padding: 40px 4% 30px;
    > div {
      margin: 10px 2% 20px;
      > label {
        display: inline-block;
        margin-right: 10px;
        i {
          display: inline-block;
          margin-right: 4px;
          font-style: normal;
          color: red;
        }
      }
    }
    h2 {
      font-size: 14px;
      font-weight: normal;
      margin-top: 20px;
      a {
        font-size: 14px;
        display: inline-block;
        color: #999;
      }
    }
    input {
      margin: 20px 30px;
    }
    .submitStyle {
      margin: 20px 0 0 80px;
      button {
        margin-left: 10px;
        display: inline-block;
      }
    }
  }
}
</style>
